import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { usePageMeta, cz } from "@/lib/site";

export default function ClientZone() {
  usePageMeta(
    "Klientská zóna — chystáme se | G&G accounting",
    "Připravujeme zabezpečené prostředí pro sdílení dokladů a přehled vašeho účetnictví."
  );

  return (
    <section className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-6 md:px-12 py-16 md:py-20 bg-cream relative overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-magenta/10 blur-3xl pointer-events-none" />
      <div className="relative max-w-2xl flex flex-col items-center text-center" data-testid="client-zone-coming-soon">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-magenta/10">
          <Lock className="w-9 h-9 text-magenta" />
        </div>
        <span className="block text-xs tracking-[0.22em] uppercase text-magenta font-semibold mt-8">
          Brzy spustíme
        </span>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-medium mt-6 leading-[1]">
          {cz("Klientská zóna se chystá.")}
        </h1>
        <p className="mt-6 text-base md:text-lg text-muted2 leading-relaxed">
          {cz("Připravujeme pro vás zabezpečené prostředí pro sdílení dokladů a přehled nad vaším účetnictvím. O spuštění vás budeme informovat.")}
        </p>
        <div className="mt-10">
          <Link
            to="/"
            data-testid="client-zone-back"
            className="inline-flex items-center gap-2 bg-magenta hover:bg-magenta-dark text-white px-7 py-3.5 rounded-full font-medium transition-colors"
          >
            Zpět na úvod <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
